import { render, staticRenderFns } from "./LastTicketsDetailsFooter.vue?vue&type=template&id=cee9910e&scoped=true"
import script from "./LastTicketsDetailsFooter.vue?vue&type=script&lang=js"
export * from "./LastTicketsDetailsFooter.vue?vue&type=script&lang=js"
import style0 from "./LastTicketsDetailsFooter.vue?vue&type=style&index=0&id=cee9910e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee9910e",
  null
  
)

export default component.exports